import e from"react";export var SettingsSubHeading=function(t){var n=t.children;return e.createElement("div",{className:"ds-settings-menu__sub-heading"},n)};